/** Fabric design / export resolution (logical pixels). Display size is scaled to fit the viewport. */
export const FABRIC_LOGICAL_WIDTH = 670;
export const FABRIC_LOGICAL_HEIGHT = 652;

export const CANVAS_CSS_SCALE_EVENT = 'welovelaser:fabric-canvas-css-scale';
